import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { dailyChanged } from "@/lib/daily";

const COLORS = ["#0f2a33", "#1b1430"];

function Wheel({ slices, angle }) {
  const n = slices.length, step = 360 / n;
  const pt = (deg, r) => [50 + r * Math.sin((deg * Math.PI) / 180), 50 - r * Math.cos((deg * Math.PI) / 180)];
  return (
    <svg viewBox="0 0 100 100" className="w-full h-full" style={{ transform: `rotate(${angle}deg)`, transition: "transform 4.5s cubic-bezier(.12,.67,.12,1)" }}>
      {slices.map((s, i) => {
        const [x1, y1] = pt(i * step - step / 2, 48), [x2, y2] = pt(i * step + step / 2, 48), [tx, ty] = pt(i * step, 32);
        const jackpot = i === n - 1;
        return (
          <g key={s}>
            <path d={`M50 50 L${x1} ${y1} A48 48 0 0 1 ${x2} ${y2} Z`} fill={jackpot ? "#a16207" : COLORS[i % 2]} stroke="#fbbf24" strokeWidth=".4" />
            <text x={tx} y={ty} fill={jackpot ? "#fff7d6" : "#fde68a"} fontSize="4" textAnchor="middle" dominantBaseline="middle" transform={`rotate(${i * step} ${tx} ${ty})`}>
              {s.replace(" credits", "").replace(" credit jackpot", "!").replace("Healing ", "").replace("Revive Token", "Revive")}
            </text>
          </g>
        );
      })}
      <circle cx="50" cy="50" r="6" fill="#0b1217" stroke="#fbbf24" strokeWidth="1" />
    </svg>
  );
}

export default function SpinWheel({ open, onClose, daily, refresh }) {
  const [angle, setAngle] = useState(0);
  const [busy, setBusy] = useState(false);
  const [prize, setPrize] = useState(null);
  const slices = daily?.spin_slices || [];

  const spin = async () => {
    setBusy(true); setPrize(null);
    try {
      const { data } = await api.post("/daily/spin");
      const step = 360 / slices.length;
      setAngle((a) => a - (a % 360) + 360 * 6 - data.slice * step);
      setTimeout(() => { setPrize(data); setBusy(false); dailyChanged(); refresh(); }, 4700);
    } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  const left = prize ? prize.spins_left : daily?.spins_left;

  return (
    <Dialog open={open} onOpenChange={(o) => !o && !busy && (setPrize(null), onClose())}>
      <DialogContent data-testid="spin-dialog" className="glass max-w-md">
        <DialogHeader>
          <p className="text-[11px] font-mono-game text-amber-300">DAILY LUCKY SPIN</p>
          <DialogTitle className="font-display text-3xl text-white">Spin the wheel</DialogTitle>
          <DialogDescription className="text-slate-300">One free spin a day. 1/1 Wolf NFT holders get a second.</DialogDescription>
        </DialogHeader>
        <div className="relative mx-auto w-72 h-72">
          <div className="absolute left-1/2 -top-1 -translate-x-1/2 z-10 w-0 h-0 border-x-[10px] border-x-transparent border-t-[18px] border-t-amber-400" />
          <Wheel slices={slices} angle={angle} />
        </div>
        {prize && <p data-testid="spin-prize" className="text-center font-display text-2xl text-amber-200 rise">You won {prize.prize}!</p>}
        <button data-testid="spin-go-btn" disabled={busy || !left} onClick={spin} className="ember-btn w-full py-3 rounded-lg text-sm">
          {busy ? "SPINNING…" : left ? `SPIN (${left} left today)` : "NO SPINS LEFT TODAY"}
        </button>
      </DialogContent>
    </Dialog>
  );
}
